import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1)
const _hoisted_2 = { class: "flex items-center justify-end mt-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_alert = _resolveComponent("alert")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["StepCreate", { 'flex items-center justify-end': !_ctx.created }])
  }, [
    (!_ctx.created)
      ? (_openBlock(), _createBlock(_component_the_button, {
          key: 0,
          class: "primary small",
          loading: _ctx.loading,
          disabled: _ctx.disabled,
          onClick: _ctx.emitSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.isFtl ? 'Создать заявку' : 'Создать заказ'), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_alert, { class: "w-full text-center success" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFtl ? 'Заявка успешно создана!' : 'Заказ успешно создан!'), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.isFtl)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_button, { class: "primary small mr-3" }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createTextVNode(" Перейти к заказам ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _ctx.emitNewOrder
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Создать новый заказ ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 64))
  ], 2))
}